import { Injectable } from '@angular/core';
import {GraphQLClientService} from './graphql-client.service';
import {MonitoringService} from '../../services/logging.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private graphQLClient: GraphQLClientService,
    private monitoringService: MonitoringService,
  ) {}

  async getServerConnectionStatus(): Promise<any> {
    const query = `query{
      serverstatus
        {
            status
        }
     }`;
    return (await this.graphQLClient.requestAsync<any>(query))?.data?.serverstatus?.status;
  }

  async getLanguageSettings(): Promise<any> {
    const query = `
      query{
        configurations{
            profileSettings{supportedLanguages {id description code2} systemLanguage {id description code2}}
        }
      }
    `;
    return (await this.graphQLClient.requestAsync<any>(query))?.data.configurations.profileSettings;
  }

}
